module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/image@2x.6ae4f8aa.jpg";